import { SocketMessageTypeEnum } from 'shared/models/Socket'

export const portalBellNotifications: SocketMessageTypeEnum[] = [
  SocketMessageTypeEnum.BellNoticeCommentChanged,
  SocketMessageTypeEnum.BellSuggestedSection,
  SocketMessageTypeEnum.BellSectionComment,
  SocketMessageTypeEnum.BellBookingCreated,
  SocketMessageTypeEnum.BellBookingCancelledByUser,
  SocketMessageTypeEnum.BellInsuranceCaseDraftAccepted,
  SocketMessageTypeEnum.BellInsuranceCaseDraftRejected,
  SocketMessageTypeEnum.BellBoardMeetingNewComment,
  SocketMessageTypeEnum.BellNewUnitOwnersReadyForApproval,
  SocketMessageTypeEnum.BellLoanImportNewInterestRate,
  SocketMessageTypeEnum.BellNewSubleaseApplication,
  SocketMessageTypeEnum.BellNewSubleaseRegistered,
  SocketMessageTypeEnum.BellSubleaseApproachingEndDate,
  SocketMessageTypeEnum.BellNewPublicationPublishedPortal,
  SocketMessageTypeEnum.BellReimbursementCreated,
  SocketMessageTypeEnum.BellNotificationMeetingCreated,
  SocketMessageTypeEnum.BellNotificationMeetingAccepted,
  SocketMessageTypeEnum.BellNotificationMeetingDeclined,
  SocketMessageTypeEnum.BellNotificationMeetingCancelled,
  SocketMessageTypeEnum.BellNotificationMeetingChanged,
  SocketMessageTypeEnum.BellNotificationMeetingComment,
  SocketMessageTypeEnum.BellNotificationMeetingAttendeeChanged,
  SocketMessageTypeEnum.BellNotificationBudgetPublishedPortal,
  SocketMessageTypeEnum.BellNotificationBudgetReadyForApproval,
  SocketMessageTypeEnum.BellNotificationBudgetApprovalDeadlineApproaching,
  SocketMessageTypeEnum.BellNotificationBudgetNewComment,
  SocketMessageTypeEnum.BellNotificationRegistreringAvMaalerstandAapen
]
